module.exports = __webpack_public_path__ + "static/media/3-8.04a1f012.mp3";